import React from "react";
import { Box, Typography, FormControl, FormLabel } from "@mui/joy";

export const ESTIMATING_CONFIG = {
    OPTIONS: {
        PAYMENT_TYPES: [
            { value: "insurance", label: "Insurance Claim" },
            { value: "cash", label: "Cash / Check" },
            { value: "credit", label: "Credit Card" },
            { value: "debit", label: "Debit Card" },
            { value: "financing", label: "Financing" },
        ],
    },
};

interface SettingFieldProps {
    label: string;
    description?: string;
    children: React.ReactNode;
    horizontal?: boolean;
}

export const SettingField = ({ label, description, children, horizontal = true }: SettingFieldProps) => {
    if (!horizontal) {
        return (
            <FormControl size="sm">
                <FormLabel sx={{ mb: 0.5 }}>{label}</FormLabel>
                {description && <Typography level="body-xs" sx={{ mb: 1 }}>{description}</Typography>}
                {children}
            </FormControl>
        );
    }

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: 2 }}>
            <Box>
                <Typography level="body-sm" fontWeight="500">{label}</Typography>
                {description && <Typography level="body-xs">{description}</Typography>}
            </Box>
            <Box sx={{ minWidth: 100 }}>
                {children}
            </Box>
        </Box>
    );
};
